import { render, staticRenderFns } from "./RpaFormPage.vue?vue&type=template&id=da0c0104&"
import script from "./RpaFormPage.vue?vue&type=script&lang=js&"
export * from "./RpaFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports